module.exports = __webpack_public_path__ + "img/11_3.2b59f7e3.png";